
<div *ngIf=actionItem style="margin-bottom: 10px;">
  <p>[{{actionItem.issueType}}] {{actionItem.title}}</p>
  <p>{{actionItem.description}}</p>

  <button class="pb-button" (click)="acceptActionItem($event)" mat-raised-button>
    Accept
  </button>

  <button class="pb-button" (click)="rejectActionItem()" mat-raised-button>
    Reject
  </button>
</div>



<template #newBklIssue></template>
